import { Injectable } from '@angular/core';
import { Store, StoreConfig } from '@datorama/akita';

export interface OrgConfigState {
  selfPurchase: boolean;
}
function createOrgConfigState() {
  return {} as OrgConfigState;
}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'org_config' })
export class OrgConfigStore extends Store<OrgConfigState> {
  constructor() {
    super(createOrgConfigState());
  }
}
